export interface Store {
  showCountriesDropdown: boolean;
  countrySearchStr: string;
  countriesList?: string[][];
  selectedCountry?: string[];
  hoveredCountry?: string[];
  phonePrefix: string;
  phoneNumber: string;
  rawPhoneValue: string;
  keepMeSign: boolean;
  showNextButton: boolean;
  userInteract: boolean;
  authState?: any;
}

export class StoreHelper {
  store: Store = {
    showCountriesDropdown: false,
    countrySearchStr: '',
    phonePrefix: '',
    phoneNumber: '',
    rawPhoneValue: '',
    keepMeSign: true,
    showNextButton: false,
    userInteract: false,
  };

  subscribes: {[key: string]: Function[]} = {};

  setStore<T extends keyof Store>(newStore: Pick<Store, T>) {
    this.store = Object.assign({}, this.store, newStore);

    Object.keys(newStore).forEach(field => {
      if (this.subscribes[field]) {
        this.subscribes[field].forEach(callback => {
          callback(this.store);
        });
      }
    });
  }

  subscribe(fields: string[], callback: Function) {
    fields.forEach(field => {
      if (!this.subscribes[field]) {
        this.subscribes[field] = [];
      }

      this.subscribes[field].push(callback);
    });
  }

  reset() {
    this.subscribes = {};
  }
}
